import {
  countUnreadNotifications,
  fetchUserNotifications,
  insertNotification,
  markAllNotificationsRead,
  markNotificationRead,
} from '@/services/notifications/notificationRepository';
import type {
  Notification,
  NotificationFilters,
  NotificationInput,
} from '@/types/notification';

export async function createNotification(
  input: NotificationInput,
): Promise<Notification> {
  if (!input.userId.trim()) {
    throw new Error('userId requerido para la notificación.');
  }
  return insertNotification(input);
}

export async function getUserNotifications(
  userId: string,
  filters?: NotificationFilters,
): Promise<Notification[]> {
  return fetchUserNotifications(userId, filters ?? {});
}

export async function markAsRead(
  notificationId: string,
  userId: string,
): Promise<void> {
  const items = await fetchUserNotifications(userId, {}, 100);
  const match = items.find((n) => n.id === notificationId);
  if (!match || match.userId !== userId) {
    throw new Error('Notificación no encontrada.');
  }
  await markNotificationRead(notificationId, userId);
}

export async function markAllAsRead(userId: string): Promise<number> {
  return markAllNotificationsRead(userId);
}

export async function getUnreadCount(userId: string): Promise<number> {
  return countUnreadNotifications(userId);
}
